import { queryClient } from 'App';
import debounce from 'lodash/debounce';

import { appointmentQueryKeys } from 'lib/constants/queries/queryKeys';

export default debounce(() => {
  appointmentQueryKeys.forEach((key) => {
    queryClient.invalidateQueries({
      queryKey: [key],
      exact: false
    });
  });
}, 300);
